import ApiClient from '@/services/apiClient';

export default class Input {
  input_number;
  input_type;   //"NO", "NC"
  label;

  constructor(input_number = 0, label = "", input_type = "NO") {
    this.input_number = input_number;
    this.label = label;
    this.input_type = input_type;
  }

  static constructFromObject(data, obj) {
    obj = obj || new Input();
    if (data) {
      obj.input_number = ApiClient.convertToType(data['input_number'], 'Integer');
      obj.input_type = ApiClient.convertToType(data['input_type'], 'String');
    }
    return obj;
  }

  toJSON() {
    return {
      input_number: this.input_number,
      input_type: this.input_type,
    }
  }

  toString() {
      return this.label;
  }
}
